export default __webpack_public_path__ + "static/media/galeria_erp01.b2d5c151.png";